import { ThumbsUpIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const ThumbUp = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <ThumbsUpIcon size={Sizes[size]} {...rest} color={fill} />;
};

ThumbUp.displayName = 'ThumbUp';
